import * as R from 'ramda';

export default function VendorManagementController(
  $q,
  $location,
  $scope,
  $rootScope,

  serviceIds,
  userService,
  orgDataService,
  loaderService,
  alerts,
  ssDialogService,
  theSafeSharedModelService,
  vmDataService,
  vmSharedModelService,
  editVendorDialog,
  // customerServiceAcceptanceDialog
) {
  const vm = this;

  vm.appIsLoaded = false;
  vm.loaderService = loaderService;

  vm.serviceId = 1;
  vm.groupId = 12;

  vm.showFilters = false;

  vm.handleShowAddVendorDialog = _handleShowAddVendorDialog;
  vm.handleToggleShowFilters = _handleToggleShowFilters;
  vm.handleClearFilters = _handleClearFilters;
  vm.handleFilterChange = _handleFilterChange;

  /* Data Models */
  vm.vendorManagers = null;
  vm.vendors = null;
  vm.settings = null;
  vm.states = null;

  vm.filters = vmSharedModelService.filters;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function _handleAddedVendor(vendor) {
    vm.unfilteredVendors.push(vendor);
    vm.unfilteredVendors = R.sortBy(R.prop('name'), vm.unfilteredVendors);
    _handleFilterChange();
  }

  // function _handleCancelCustomerServiceAcceptance() {
  //  alerts.warning('In order to use Vendor Management, EULA acceptance is required.');
  //  $location.path('/');
  // }

  function _handleToggleShowFilters() {
    vm.showFilters = !vm.showFilters;
  }

  function _handleFilterChange() {
    loaderService.showViewLoader = true;
    const _vendors = vmSharedModelService.filterVendors(vm.unfilteredVendors);

    if (_vendors !== undefined) {
      const dfdRefresh = $q.defer();

      if (vm.filters.selectedVendorManagerId > 0) {
        vmDataService.getVendorsByVendorManagers(vm.filters.selectedVendorManagerId).then((response) => {
          let vmVendors = response.data.result;
          vmVendors = R.filter(R.propEq('isSelected', true))(vmVendors);

          if ((vmVendors !== undefined) && (vmVendors.length > 0)) {
            const matchedVendors = [];
            R.forEach((vendor) => {
              R.forEach((vmVendor) => {
                if (vendor.vendorId === vmVendor.vendorId) {
                  matchedVendors.push(vendor);
                }
              }, vmVendors);
            }, _vendors);
            vm.vendors = matchedVendors;
          } else {
            vm.vendors = [];
          }

          loaderService.showViewLoader = false;
          dfdRefresh.resolve();
        });
      } else {
        loaderService.showViewLoader = false;
        vm.vendors = _vendors;
        dfdRefresh.resolve();
      }

      return dfdRefresh.promise;
    }
  }

  function _handleClearFilters() {
    vm.filters = vmSharedModelService.clearFilters();
    vm.vendors = vmSharedModelService.filterVendors(vm.unfilteredVendors);
  }

  function _handleShowAddVendorDialog($event) {
    return _showEditVendorDialog($event, {
      vendor: vmSharedModelService.createNewVendor({ sdnScore: -1, countryId: 1 }),
      addCallback: _handleAddedVendor,
    });
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    _initPermissions();
    _initPage().then(() => {
      vm.appIsLoaded = true;
    });
    _initEventListeners();
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('vendorManagement')
      .then((permissions) => {
        loaderService.showViewLoader = false;
        vm.permissions = permissions;
      });
  }

  function _initPage() {
    return vmSharedModelService.initVendorManagement(vm.serviceId).then((initVendorManagementResponse) => {
      //
      // const requiresServiceAcceptance = initVendorManagementResponse.data.eluaRequired;
      // const hasServiceAcceptance = initVendorManagementResponse.data.serviceEulaAcceptance.recordCount > 0;
      // if (requiresServiceAcceptance && !hasServiceAcceptance) {
      //   return _showCustomerServiceAcceptance();
      // }
      vm.eulaAccepted = true;
      vm.riskTiers = initVendorManagementResponse.data.riskTierRating.result;
      vm.settings = initVendorManagementResponse.data.settingsDefaults.result;
      vm.vendorManagers = initVendorManagementResponse.data.vendorManagers.result;
      vm.unfilteredVendors = initVendorManagementResponse.data.vendors.result;
      vm.vendors = vm.unfilteredVendors;
      if (initVendorManagementResponse.data.notificationUsers !== null) { 
        vm.notifications = initVendorManagementResponse.data.notificationUsers.result;
      }
      if (initVendorManagementResponse.data.settingsDefaults.result.length > 0) {
        vm.lastBoardReviewDate = initVendorManagementResponse.data.settingsDefaults.result[0].lastBoardReviewDate;
      }

      $rootScope.$broadcast('vmNotificationsLoaded', {
        notifications: vm.notifications,
        lastBoardReviewDate: vm.lastBoardReviewDate,
      });

      _handleClearFilters();
    });
  }

  // function _verifyServiceAcceptance() {
  //   return userService.getUser()
  //     .then((user) => {
  //       $q.all([
  //         orgDataService.isCSARequired(user.customerId, serviceIds.vendorManagement),
  //         orgDataService.getCSAText(serviceIds.vendorManagement)
  //       ])
  //         .then((results) => {
  //           const requiresServiceAcceptance = results[0].data.result;
  //           const eula = results[1].data.result[0];
  //           return orgDataService.getEULAServiceAcceptanceByCustomer(user.customerId, eula.serviceEulaId)
  //             .then((acceptanceResponse) => {
  //               const hasServiceAcceptance = (acceptanceResponse.data.recordCount > 0);
  //
  //               if (!hasServiceAcceptance && requiresServiceAcceptance) {
  //                 return _showCustomerServiceAcceptance();
  //               }
  //
  //               vm.eulaAccepted = true;
  //               return _initPage();
  //             });
  //         });
  //     });
  // }

  function _initEventListeners() {
    $scope.$on('reloadVMData', () => {
      vmSharedModelService.getVendors(vm.serviceId, true).then((response) => {
        vm.vendors = response;
        vm.unfilteredVendors = vm.vendors;
      });
    });

    $scope.$on('filterVendors', () => {
      vm.vendors = vmSharedModelService.filterVendors(vm.unfilteredVendors);
    });

    $scope.$on('initVMPage', () => {
      loaderService.showViewLoader = true;
      _initPage().then(() => {
        loaderService.showViewLoader = false;
      });
    });
  }

  // function _initPage() {
  //   loaderService.showViewLoader = true;
  //   return vmSharedModelService.initVendorManagement().then(() => {
  //     $q.all([
  //       vmSharedModelService.getVendors(vm.serviceId, true),
  //       vmSharedModelService.getSettings(true),
  //     ]).then((results) => {
  //       vm.vendors = results[0];
  //       vm.settings = results[1];
  //       loaderService.showViewLoader = false;
  //     });
  //   });
  // }

  // //// Customer Service Acceptance //////

  // function _showCustomerServiceAcceptance() {
  //  return customerServiceAcceptanceDialog.show(
  //    serviceIds.vendorManagement,
  //    _customerAcceptedServiceAgreement,
  //    _handleCancelCustomerServiceAcceptance
  //  );
  // }

  // function _customerAcceptedServiceAgreement() {
  //   loaderService.showViewLoader = true;
  //   return _initPage().then(() => {
  //     loaderService.showViewLoader = false;
  //     vm.appIsLoaded = true;
  //   });
  // }

  function _showEditVendorDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editVendorDialog = ssDialogService.alert(
      editVendorDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editVendorDialog);
  }
}

VendorManagementController.$inject = [
  '$q',
  '$location',
  '$scope',
  '$rootScope',

  'serviceIds',
  'userService',
  'orgDataService',
  'loaderService',
  'alerts',
  'ssDialogService',
  'theSafeSharedModelService',
  'vmDataService',
  'vmSharedModelService',
  'editVendorDialog',
  'customerServiceAcceptanceDialog',
];
